import { render, staticRenderFns } from "./listasprecios.vue?vue&type=template&id=b612ee0e"
import script from "./listasprecios.vue?vue&type=script&lang=js"
export * from "./listasprecios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports